import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { LoginPage } from '../../components/features/login/LoginPage';

import { ssoConfigQueryOptions } from '@/api/endpoints/auth';
import { PlainLayout } from '@/modus/PlainLayout';
import { Wordmark } from '@/modus/Wordmark';

export const Route = createFileRoute('/_public/login')({
  beforeLoad: async ({ context: { queryClient } }) => {
    await queryClient.prefetchQuery(ssoConfigQueryOptions());
  },
  validateSearch: z.object({
    error: z.string().optional(),
    redirectTo: z.string().optional(),
  }),
  pendingComponent: () => (
    <PlainLayout main className="flex h-screen w-screen items-center justify-center overflow-hidden">
      <div className="bg-tlai-card border border-muted rounded-2xl w-full max-w-xs p-6">
        <div className="py-8 flex items-center justify-center">
          <Wordmark
            size={200}
            loading
            className="w-[300px] sm:w-[400px]"
            style={{ filter: 'drop-shadow(0 0 8px #ffffff40)' }}
          />
        </div>
      </div>
    </PlainLayout>
  ),
  component: RouteComponent,
});

function RouteComponent() {
  const { redirectTo } = Route.useSearch();
  return <LoginPage redirectTo={redirectTo} />;
}
